import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../styles/Mechhero.css'; // You can rename this CSS file if needed
import img1 from '../assets/cg5.jpg';
import img2 from '../assets/cg6.jpg';
import img3 from '../assets/cg2.jpg';
import img4 from '../assets/cg1.jpg';
import img5 from '../assets/cg9.avif';

const Civilhero = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="civilhero-container">
      <div className="civilhero-row">
        <div className="civilhero-box" data-aos="fade-right" data-aos-delay="0">
          <img src={img1} alt="Civil Design 1" />
        </div>
        <div className="civilhero-box" data-aos="fade-up" data-aos-delay="100">
          <h3>Structural Layouts</h3>
          <p>
            Our structural layout services offer robust and code-compliant frameworks for civil projects. We ensure optimal load distribution, material efficiency, and long-term durability for both residential and commercial buildings.
          </p>
        </div>
        <div className="civilhero-box" data-aos="fade-left" data-aos-delay="200">
          <img src={img2} alt="Civil Design 2" />
        </div>
      </div>

      <div className="civilhero-row">
        <div className="civilhero-box" data-aos="fade-right" data-aos-delay="0">
          <h3>Civil CAD Drafting</h3>
          <p>
            Our Civil AutoCAD services deliver precise 2D and 3D drafting for site plans, grading, drainage systems, and utility layouts. We collaborate with engineers to ensure drawings meet project needs and regulatory standards.
          </p>
        </div>
        <div className="civilhero-box res-box" data-aos="fade-up" data-aos-delay="100">
          <img src={img3} alt="Site Layout" />
        </div>
        <div className="civilhero-box" data-aos="fade-left" data-aos-delay="200">
          <h3>Project Execution</h3>
          <p>
            From excavation to final handover, our civil execution services manage every stage with precision. We ensure adherence to structural plans, timely delivery, safety compliance, and high construction standards across all project types.
          </p>
        </div>
      </div>

      <div className="civilhero-row">
        <div className="civilhero-box" data-aos="fade-right" data-aos-delay="0">
          <img src={img4} alt="Foundation Design" />
        </div>
        <div className="civilhero-box" data-aos="fade-up" data-aos-delay="100">
          <h3>Civil Engineering Consultation</h3>
          <p>
            We provide expert consultation for infrastructure, land development, and construction projects. Our team assists with feasibility studies, planning, and design review to ensure your project is optimized for cost, compliance, and longevity.
          </p>
        </div>
        <div className="civilhero-box" data-aos="fade-left" data-aos-delay="200">
          <img src={img5} alt="Construction Plan" />
        </div>
      </div>
    </div>
  );
};

export default Civilhero;
